import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { TrackRequest, TrackRequestModel } from "@tsin-core/states/track/track.model";
import { environment } from "@tsin-env/environment";
import { Observable, catchError, throwError } from "rxjs";

const BASE_URL = `${environment.apiUrl2}`;

@Injectable({
    providedIn: 'root'
})

export class TrackService {

    http: HttpClient = inject(HttpClient);

    getTracks(): Observable<TrackRequestModel[]> {
        return this.http.get<TrackRequestModel[]>(`${BASE_URL}/track`).pipe(
            catchError(error => {
                console.error('Error fetching tracks:', error);
                return throwError(() => error);
            })
        );
    }
    getTrack(id: string): Observable<TrackRequestModel> {
        return this.http.get<TrackRequestModel>(`${BASE_URL}/track/single/${id}`).pipe(
            catchError(error => {
                console.error('Error fetching tracks:', error);
                return throwError(() => error);
            })
        );
    }

    createTrack(formData: Omit<TrackRequest, 'id'>): Observable<TrackRequestModel> {
        return this.http.post<TrackRequestModel>(`${BASE_URL}/track`, formData).pipe(
            catchError(error => {
                console.error('Error fetching tracks:', error);
                return throwError(() => error);
            })
        );
    }

    updateTrack(formData: TrackRequest): Observable<TrackRequestModel> {
        return this.http.put<TrackRequestModel>(`${BASE_URL}/track`, formData).pipe(
            catchError(error => {
                console.error('Error fetching tracks:', error);
                return throwError(() => error);
            })
        );
    }

   deleteTrack(id: string): Observable<TrackRequestModel> {
        return this.http.delete<TrackRequestModel>(`${BASE_URL}/track/single/${id}`).pipe(
            catchError(error => {
                console.error('Error fetching tracks:', error);
                return throwError(() => error);
            })
        );
    }

    getTracksByAdministration(administrationId: string): Observable<TrackRequestModel[]> {
        return this.http.get<TrackRequestModel[]>(`${BASE_URL}/track/administration/${administrationId}`).pipe(
            catchError(error => {
                console.error('Error fetching tracks by administration:', error);
                return throwError(() => error);
            })
        );
    }

}
